export type ProductType = 'beat' | 'cover' | 'feature' | 'mix' | 'kit' | 'service';

export const DELIVERY_OPTIONS_BY_TYPE: Record<ProductType, { id: string; label: string; required?: boolean }[]> = {
  beat: [
    { id: 'mp3', label: 'MP3', required: false },
    { id: 'wav', label: 'WAV', required: false },
    { id: 'mp3+wav', label: 'MP3 + WAV', required: false },
    { id: 'stems', label: 'Stems (ZIP)', required: false },
    { id: 'project', label: 'Project File', required: false },
  ],
  cover: [
    { id: 'png', label: 'PNG' },
    { id: 'jpg', label: 'JPG' },
    { id: 'psd', label: 'PSD (source file)' },
  ],
  feature: [
    { id: 'wav', label: 'WAV (вокал)' },
    { id: 'project', label: 'Проєкт DAW' },
  ],
  mix: [
    { id: 'wav', label: 'WAV (mixed)' },
    { id: 'mp3', label: 'MP3 (mixed)' },
  ],
  kit: [{ id: 'zip', label: 'ZIP (пакет файлів)', required: true }],
  service: [],
};

export const DAW_OPTIONS = [
  'FL Studio',
  'Ableton Live',
  'Logic Pro',
  'Pro Tools',
  'Cubase',
  'Studio One',
  'Reaper',
  'GarageBand',
  'Reason',
  'Bitwig',
  'Other'
];
